<template>
  <div>
    <crud-template
        :editedItem.sync="formData"
        @dialogClosed="clearForm" ref="formTemplate">
      <template #default="{editItemHandler}">
        <div class="text-right mb-3">
          <btn-with-tooltip @click="editItemHandler('create')" class-name="action-btn" color="primary">
            <v-icon small>fas fa-plus</v-icon>
            <template #tooltip>Создать</template>
          </btn-with-tooltip>
        </div>
        <v-data-table
            :headers="headers"
            :items="items"
            disable-pagination
            hide-default-footer>
          <template #item.status="{item}">
            {{ item.status ? 'Активно' : 'Не активно' }}
          </template>
          <template #item.action="{item}">
            <div class="action-btn-wrap">
              <v-btn @click="editItemHandler('edit', item)" class="action-btn" color="warning">
                <v-icon x-small>fas fa-pencil-alt</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
        <v-pagination
            v-if="options.last_page > 1"
            v-model="options.current_page"
            :length="options.last_page"
        ></v-pagination>
      </template>
      <template #form-content="{loading, isUpdate}">
        <validation-observer ref="formObs" v-slot="{handleSubmit}">
          <form @submit.prevent="handleSubmit(() => {save(isUpdate)})">
            <custom-input-text
                label="Название"
                name="Название"
                rules="required"
                type="text"
                v-model="formData.name"
                vid="price"
            ></custom-input-text>
            <custom-input-text
                label="Логин"
                name="Логин"
                rules="required"
                type="text"
                v-model="formData.login"
                vid="price"
            ></custom-input-text>
            <custom-input-text
                label="Пароль"
                name="Пароль"
                rules="required"
                type="text"
                v-model="formData.password"
                vid="price"
            ></custom-input-text>
            <custom-input-text
                label="pHead"
                name="pHead"
                rules="required"
                type="text"
                v-model="formData.p_head"
                vid="price"
            ></custom-input-text>
            <custom-input-text
                label="pCode"
                name="pCode"
                rules="required"
                type="numeric"
                v-model="formData.p_code"
                vid="price"
            ></custom-input-text>
            <v-switch
                class="mt-0"
                dense
                :true-value="10"
                :false-value="0"
                v-model="formData.status"
                label="Статус"
            ></v-switch>
            <v-btn :loading="loading" color="primary" type="submit" width="100%">Сохранить</v-btn>
          </form>
        </validation-observer>
      </template>
    </crud-template>
  </div>
</template>

<script>
import CrudTemplate from '@/components/ui/crud/template'
import {messages} from '@/utils/constants'

export default {
  name: "index",
  data() {
    return {
      items: [],
      headers: [
        {
          text: 'Название',
          value: 'name'
        },
        {
          text: 'Логин',
          value: 'login'
        },
        {
          text: 'Пароль',
          value: 'password'
        },
        {
          text: 'pHead',
          value: 'p_head'
        },
        {
          text: 'pCode',
          value: 'p_code'
        },
        {
          text: 'Статус',
          value: 'status'
        },
        {
          text: 'Действие',
          value: 'action'
        }
      ],
      formData: {
        id: null,
        name: null,
        login: null,
        password: null,
        p_head: null,
        p_code: null,
        status: null,
      },
      options: {
        last_page: 1,
        current_page: 1
      }
    }
  },
  methods: {
    clearForm() {
      const {formObs} = this.$refs
      if (formObs) formObs.reset()
    },
    async getItems() {
      let params = {
        page: this.options.current_page
      }
      try {
        const {data: {data, links: {last_page}}} = await this.$http.get('admin/katm-users', {params})
        this.items = data
        this.options.last_page = last_page
      } catch (e) {
        this.$setResponseError({error: e})
      }

    },
    async save(isUpdate) {
      const {formTemplate} = this.$refs
      formTemplate.$showFormLoading()
      await this.createOrUpdate()
      formTemplate.$clearFormLoading()
    },
    async createOrUpdate() {
      try {
        const {formTemplate} = this.$refs
        await this.$http.post('admin/katm-users', this.formData)
        await this.getItems()
        formTemplate.closeFormDialog()
        this.$setSuccess({text: messages.onSave})
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs['formObs']})
      }
    },
  },
  components: {CrudTemplate},
  async created() {
    this.$showLoading()
    await this.getItems()
    this.$clearLoading()
  },
  watch: {
    "options.current_page": "getItems"
  }
}
</script>

<style scoped>

</style>